module.exports = __webpack_public_path__ + "public/images/math.d90d317f4cad9c9352ec34827537fa81.png";